import React, { useMemo } from 'react';
import { APP_TYPE_ANY } from '../../types/common.types';
import { WordWithoutBreak } from '../../styles/common';

interface UseProcessFormFieldsParams {
  formFieldsData: APP_TYPE_ANY[] | null | undefined;
}

interface UseProcessFormFieldsReturn {
  processedFormFieldsData: APP_TYPE_ANY[];
}

/**
 * Hook to process form fields data by wrapping selector endContent with WordWithoutBreak component
 * @param formFieldsData - Array of form field data to process
 * @returns Processed form fields data with WordWithoutBreak wrapper for FormGroupSelectors
 */
export const useProcessFormFields = ({
  formFieldsData
}: UseProcessFormFieldsParams): UseProcessFormFieldsReturn => {
  const processedFormFieldsData = useMemo(() => {
    return (formFieldsData || []).map((field: APP_TYPE_ANY) => {
      if (field?.component === 'FormGroupSelectors') {
        return {
          ...field,
          selectorsList: field.selectorsList?.map(selector => ({
            ...selector,
            endContent: (
              <WordWithoutBreak>{selector.endContent || ''}</WordWithoutBreak>
            )
          }))
        };
      }
      return field;
    });
  }, [formFieldsData]);

  return { processedFormFieldsData };
};

export default useProcessFormFields;
